import React, { useState, useMemo } from 'react'
import {
  Button,
  Container,
  Paper,
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Typography,
  Stack,
  Box,
} from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import { useCreateMapTrans, useGetMapTrans } from '../../../hooks/api/map-transactions'
import Form from './Form'
import Row from './Row'
import ErrorMessage from '../../errors/ErrorMessage'
import { LoadingSkeletonRows } from '../../_ui/LoadingSkeletonRows'
import NoTransaction from './NoTransaction'

export const TransactionScreen = () => {
  const [open, setOpen] = useState(false)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  const { id: mapId } = useParams()
  const navigate = useNavigate()

  const defaultValues = useMemo(() => ({ mapId }), [mapId])

  const { data, isLoading, refetch, error } = useGetMapTrans(mapId, {
    page: page + 1,
    limit: rowsPerPage,
  })

  const transactions = data?.docs || []

  return (
    <Container style={{ paddingTop: '2rem' }}>
      <Stack direction='row' alignItems='center' justifyContent='space-between' spacing={2} mb={3}>
        <Button variant='outlined' onClick={() => navigate(-1)}>
          Back
        </Button>
        <Typography variant='h5' fontWeight={600}>
          Transactions
        </Typography>
        <Button variant='contained' onClick={() => setOpen(true)}>
          Add
        </Button>
      </Stack>
      <Box paddingTop={'2rem'}>
        {error ? (
          <ErrorMessage error={error} onRetry={refetch} />
        ) : data?.docs?.length > 0 || isLoading ? (
          <Paper>
            <TableContainer>
              <MuiTable size='small'>
                <TableHead>
                  <TableRow>
                    <TableCell width={'20%'}>Date</TableCell>
                    <TableCell width={'50%'}>Description</TableCell>
                    <TableCell width={'10%'}>Type</TableCell>
                    <TableCell width={'10%'}>Amount</TableCell>
                    <TableCell width={'10%'}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isLoading ? (
                    <LoadingSkeletonRows rows={10} length={5} />
                  ) : (
                    transactions.map((trans) => (
                      <Row key={trans.id} data={trans} refetch={refetch} />
                    ))
                  )}
                </TableBody>
              </MuiTable>
            </TableContainer>
            {!isLoading && (
              <TablePagination
                component='div'
                count={data?.totalDocs || 0}
                page={page}
                onPageChange={(_, newPage) => setPage(newPage)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => {
                  setRowsPerPage(+e.target.value)
                  setPage(0)
                }}
              />
            )}
          </Paper>
        ) : (
          <NoTransaction mapId={mapId} refetch={refetch} />
        )}
      </Box>
      <Form
        defaultValues={defaultValues}
        open={open}
        setOpen={setOpen}
        api={useCreateMapTrans}
        refetch={refetch}
        isCreateMode
      />
    </Container>
  )
}
